import React from 'react';
import { Form, Input, Select } from 'antd';
import { GridLayout } from '../GridLayout';
import { SubsectionHeader } from '../SubsectionHeader';
import { SectionDivider } from '../SectionDivider';
import { spacing } from '../../design-system/tokens';

const { Option } = Select;
const { TextArea } = Input;

const paymentTermsOptions = [
  'Net 30',
  'Net 60', 
  'Net 90',
  'COD',
  'Wire Transfer',
  'Letter of Credit',
  'Documents Against Payment',
  'Documents Against Acceptance',
  'Open Account',
  'Other'
];

const paymentBasisOptions = [
  'FOB Origin',
  'FOB Destination',
  'CIF',
  'CFR',
  'EXW',
  'FCA',
  'CPT',
  'CIP',
  'DAT',
  'DAP',
  'DDP',
  'Other'
];

export const ContractPaymentForm: React.FC = () => {
  return (
    <div>
      <SubsectionHeader title="Seller Payment Terms" />
      <GridLayout columns="1fr 1fr" style={{ marginTop: spacing.lg }}>
        <Form.Item
          name="sellerTerms"
          label="Payment Terms"
          rules={[{ required: true, message: 'Seller payment terms are required' }]}
        >
          <Select placeholder="Select payment terms">
            {paymentTermsOptions.map(term => (
              <Option key={term} value={term}>{term}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="sellerBasis"
          label="Payment Basis"
          rules={[{ required: true, message: 'Seller payment basis is required' }]}
        >
          <Select placeholder="Select payment basis">
            {paymentBasisOptions.map(basis => (
              <Option key={basis} value={basis}>{basis}</Option>
            ))}
          </Select>
        </Form.Item>
      </GridLayout>

      <Form.Item
        name="sellerTermsDetails"
        label="Additional Seller Terms"
        style={{ marginTop: spacing.md }}
      >
        <TextArea 
          rows={3} 
          placeholder="Any additional payment terms or conditions for the seller..."
        />
      </Form.Item>

      <SectionDivider margin="xl" />

      <SubsectionHeader title="Buyer Payment Terms" />
      <GridLayout columns="1fr 1fr" style={{ marginTop: spacing.lg }}>
        <Form.Item
          name="buyerTerms"
          label="Payment Terms"
          rules={[{ required: true, message: 'Buyer payment terms are required' }]}
        >
          <Select placeholder="Select payment terms">
            {paymentTermsOptions.map(term => (
              <Option key={term} value={term}>{term}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="buyerBasis"
          label="Payment Basis"
          rules={[{ required: true, message: 'Buyer payment basis is required' }]}
        >
          <Select placeholder="Select payment basis">
            {paymentBasisOptions.map(basis => (
              <Option key={basis} value={basis}>{basis}</Option>
            ))}
          </Select>
        </Form.Item>
      </GridLayout>

      <Form.Item
        name="buyerTermsDetails"
        label="Additional Buyer Terms"
        style={{ marginTop: spacing.md }}
      >
        <TextArea 
          rows={3} 
          placeholder="Any additional payment terms or conditions for the buyer..."
        />
      </Form.Item>

      <SectionDivider margin="xl" />

      <SubsectionHeader title="Commission Information" />
      <GridLayout columns="1fr 1fr 1fr 1fr" style={{ marginTop: spacing.lg }}>
        <Form.Item
          name="commissionRate"
          label="Commission Rate (%)"
          initialValue={2.0}
        >
          <Input 
            suffix="%"
            type="number"
            step="0.1"
            min="0"
          />
        </Form.Item>

        <Form.Item
          name="commissionShare"
          label="Commission Share (%)"
          initialValue={40}
        >
          <Input 
            suffix="%"
            type="number"
            step="0.1"
            min="0"
            max="100"
          />
        </Form.Item>

        <Form.Item
          name="marginShare"
          label="Margin Share (%)"
          initialValue={50.0}
        >
          <Input 
            suffix="%"
            type="number"
            step="0.1"
            min="0"
            max="100"
          />
        </Form.Item>

        <Form.Item
          name="paymentSchedule"
          label="Payment Schedule"
        >
          <Select placeholder="Select schedule">
            <Option value="upon-delivery">Upon Delivery</Option>
            <Option value="monthly">Monthly</Option>
            <Option value="quarterly">Quarterly</Option>
            <Option value="per-shipment">Per Shipment</Option>
          </Select>
        </Form.Item>
      </GridLayout>
    </div>
  );
};